const ThemeColor = {
    palette: {
        mainBackgroundColor: 'linear-gradient(175.27deg, #0274BC 17.14%, #0985D3 56.24%, #0097F6 87.97%), linear-gradient(180deg, #0274BC 0%, rgba(0, 128, 209, 0) 100%)',
        white:'#FFFFFF',
        ButtonColor:'#04AB44',
        InputTextColor:'#000000',
        SidebarButton:'#00DC08',  
        PlaceholderText:'#89939E',  
        DisableButtonColor:'#C5C5C5',
        LightGrayColor:'#F2F2F2' , 
        BrandColor: '#3107AA',
        backgroundColor:'#F0F0F0',
        InactiveText:'#E70707',
        ActiveText:'#036800',
        BrandColor: '#3107AA', 
        
        TableButton: '#4642FF',
        Primarytext1: '#333333',
        primarytext2 :'#200E32',
        InputLabel:'#A3A3A3',
        mainSkyBlue:'#1F78FF',
        PrimaryRed :'#E70707',
      },
};
export default ThemeColor;